import Paper from "@mui/material/Paper"
import ProblemsTable from "./ProblemsTable";

import FamilyHistoryTable from "./FamilyHistoryTable";
import SocialHistory from "./SocialHistory";
import AllergyTable from "./AllergyTable";
import PhysicalExaminationTable from "./PhyisicalExamination";
import ManagementPlan from "../../../EMR/components/ManagementPlan/ManagementPlan";
import TreatmentPlan from "../../../EMR/components/ManagementPlan/TreatmentPlan";
import ClinicalImpression from "../../../EMR/components/ManagementPlan/ClinicalImpression";


function EmrDetails() {

          return (
            <div className="grid grid-cols-2 gap-x-2 gap-3 w-full  overflow-y-auto p-2">
            <Paper className="p-2">
              <ProblemsTable/>
            </Paper>
            <Paper className="p-2">
              <FamilyHistoryTable/>
            </Paper>
            <Paper className="p-2">
           <SocialHistory/>
            </Paper>
             <Paper className="p-2">
              <AllergyTable/>
            </Paper>
            <Paper className="p-2">
              <PhysicalExaminationTable/>
            </Paper>
            <Paper className="p-2">
              <ManagementPlan/>
            </Paper>
            <Paper className="p-2">
              <TreatmentPlan/>
            </Paper>
            <Paper className="p-2">
              <ClinicalImpression/>
            </Paper>
          </div>
          
  )
}

export default EmrDetails
